import {PreventionInvalidityCode} from "../../preventative-interactions";

/**
 * Splits a cell value into trimmed tokens using the configured delimiter.
 * @param {*} value
 * @param {string} [splitter=',']
 * @returns {string[]}
 */
export const parseDelimitedList = (value, splitter = ',') => {
    if (Array.isArray(value)) {
        return value.map((s) => String(s).trim()).filter(Boolean);
    }
    if (value == null || value === '') {
        return [];
    }
    const delimiter = splitter ?? ',';
    return String(value)
        .split(delimiter)
        .map((s) => s.trim())
        .filter(Boolean);
};

/**
 * Joins serial tokens for display/export using the configured delimiter.
 * @param {string[]|null|undefined} serials
 * @param {string} [splitter=',']
 * @returns {string}
 */
export const joinDelimitedList = (serials, splitter = ',') => {
    if (!Array.isArray(serials) || !serials.length) {
        return '';
    }
    return serials.map((s) => String(s).trim()).filter(Boolean).join(splitter ?? ',');
};

/**
 * Distinct serial numbers (order preserved by first occurrence).
 * @param {string[]} serials
 * @returns {string[]}
 */
export const toDistinctSerials = (serials) => [...new Set(serials)];

/**
 * Parses a non-negative numeric cell value; returns NaN when missing or invalid.
 * @param {*} value
 * @returns {number}
 */
export const parseNonNegativeNumber = (value) => {
    if (value === undefined || value === null || value === '') {
        return NaN;
    }
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
        return NaN;
    }
    return n;
};

/**
 * Serials are optional. When any are provided, quantity must be a positive integer
 * that matches the distinct serial count. Rows without serials are treated as unserialized.
 * @param {{ qty: number, distinctSerialCount: number }} args
 * @returns {string[]}
 */
export const applyQtySerialRules = ({qty, distinctSerialCount}) => {
    if (distinctSerialCount <= 0) {
        return [];
    }
    if (!Number.isInteger(qty) || qty <= 0 || distinctSerialCount !== qty) {
        return [PreventionInvalidityCode.SERIAL_COUNT_MISMATCH];
    }
    return [];
};
